import { gql } from '@apollo/client';

export default gql`
  query getCustomerDetails($membershipNumber: String, $email: String, $bookingReference: String) {
    getCustomerDetails(membershipNumber: $membershipNumber, email: $email, bookingReference: $bookingReference) {
      name
      firstName
      lastName
      address {
        street
        city
        postalCode
        countryCode
      }
      emailAddress
      phoneNumber
      marketingPreferences {
        clubEurostarOptin
        trainsOptin
        hotelsOptin
        tripsOptin
      }
      nominatedPerson
      nominatedPassphrase
      nominatedPerson2
      nominatedPassphrase2
      favouriteTravellers {
        lastName
        firstName
        membershipNumber
      }
      profile {
        loyalty {
          membershipNumber
          registrationDateTime
          membershipStartDateTime
          membershipEndDateTime
          status
          statusPoints
          statusPointsSummary {
            nextQualifyingPointsResetDate
            pointsBalance
            totalPointsAccrued
            totalPointsExpired
            totalPointsRedeemed
          }
          rewardPoints
          rewardPointsSummary {
            nextQualifyingPointsResetDate
            pointsBalance
            totalPointsAccrued
            totalPointsExpired
            totalPointsRedeemed
          }
          numberOfTrips
          tier {
            name
            code
            pointsToRemainInTier
            pointsToNextTier
            tripsToRemainInTier
            tripsToNextTier
            nextTierName
            tierEffectiveDate
            tierExpirationDate
            tierCode
            pointsResetDate
            manualTierImmunityLevel
            subscriptionTierImmunityLevel
          }
        }
        customerId
        salesforceId
        nationality
        dateOfBirth
      }
    }
  }
`;
